import { render, staticRenderFns } from "./DrillSetupSlider.vue?vue&type=template&id=1f38a34e&"
import script from "./DrillSetupSlider.vue?vue&type=script&lang=js&"
export * from "./DrillSetupSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VCardText,VSlider})
